import { Field, Text } from "@sitecore-jss/sitecore-jss-react";
import React, { useState } from "react";

import { fetchDictionary } from "../../../api/genericData";
import { Button } from "../../../components/buttons/Button";
import { DupQuotationOverview } from "../../../components/quotationOverview/dup/DupQuotationOverview";
import { Step } from "../../../components/stepIndicator/Step";
import { StepIndicator } from "../../../components/stepIndicator/StepIndicator";
import { useDidMount } from "../../../hooks/useDidMount";
import { useDupFlowContext } from "../../../hooks/useDupContext";
import styles from "./DupFlowStepThree.module.scss";

interface Props {
  fields: Record<string, Field<string>>;
}

export const DupFlowStepThree = (props: Props) => {
  const { data, goToStepFour, currentStep, goBack, premium } = useDupFlowContext();
  const [dictionary, setDictionary] = useState<Record<string, string>>({});

  const goToStep4 = () => goToStepFour(props.fields.Step4Path.value);

  useDidMount(async () => {
    if (currentStep !== 3) {
      goBack(1, props.fields.Step2Path.value);
    } else {
      const { phrases } = await fetchDictionary();
      setDictionary(phrases);
    }
  });

  const handleStepClick = (index: number) => () => {
    if (index === 0) {
      goBack(1, props.fields.Step1Path.value);
    }

    if (index === 1) {
      goBack(2, props.fields.Step2Path.value);
    }
  };

  if (currentStep !== 3) {
    return null;
  }

  const firstInsured = data.insuredPersons.find((insuredPerson) => insuredPerson.isDefault);

  if (!firstInsured) {
    return null;
  }

  return (
    <>
      <StepIndicator handleClick={handleStepClick} activeStepIndex={2}>
        <Step label={props.fields.step1Name.value} labelMobile={props.fields.step1MobileName.value} />
        <Step label={props.fields.step2Name.value} labelMobile={props.fields.step2MobileName.value} />
        <Step label={props.fields.step3Name.value} labelMobile={props.fields.step3MobileName.value} />
        <Step label={props.fields.step4Name.value} labelMobile={props.fields.step4MobileName.value} />
      </StepIndicator>
      <section className={styles.dupFlowStepThree__wrapper}>
        <DupQuotationOverview
          defaultCoverage={data.defaultCoverage}
          insuredPersons={data.insuredPersons}
          premium={premium}
          paymentTerm={data.paymentTerm}
          dictionary={dictionary}
          policyCosts={props.fields.PolicyCostValue.value}
          showDisclaimer
        />

        <div className={styles.dupFlowStepThree__buttons}>
          <Button id="button_share" onClick={() => window.print()} type="outlined">
            <Text field={props.fields.ShareButtonText} />
          </Button>

          <Button
            id="button_submit_quotation"
            leading={<i className={`icon icon-pencil ${styles["dupFlowStepThree__submit-button-icon"]}`} />}
            onClick={goToStep4}
            type="primary"
          >
            <Text field={props.fields.QuotationSubmitButtonText}></Text>
          </Button>
        </div>
      </section>
    </>
  );
};
